// Define the desired order of workflow IDs
const workflowOrder = [
  'virtual-staging',
  'fast-staging',
  'furniture-removal',
  'refurnish',
  'staging',
  'inpaint',
  'render-enhancer',
  'ai-chat',
  'document-generator',
  'video-generator',
  'image-editor'
];

// Define all workflows in an object for easy lookup
const workflowsById = {
  'virtual-staging': {
    id: 'virtual-staging',
    title: 'Sanal Dizayn',
    description: 'Boş mekanları mobilyalı iç tasarımlara dönüştürün',
    longDescription: 'Boş odalarınızı mobilyalı iç mekanlara dönüştürün. Sadece seçilen alanlar değiştirilir.',
    icon: '🎯',
    deploymentId: 'eae20bdc-9da8-46de-8279-fb1652cf0268',
    mode: 'virtual-staging',
    imageUrl: '/workflow-images/virtual-staging.jpg',
    credits: '10',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: false,
    defaultStyle: 'contemporary',
    additionalInputs: {
      room_type: {
        options: ["Living Room", "Bedroom", "Kitchen", "Bathroom", "Dining Room"],
        label: "Oda Tipi"
      },
      style: {
        options: ["scandinavian", "contemporary", "modern", "minimalist", "bohemian", "japandi", "parisian", "eclectic"],
        label: "Stil"
      },
      color_theme: {
        options: ["original", "red", "blue", "green", "yellow", "brown", "white", "black", "grey", "purple", "pink", "orange"],
        label: "Renk Teması"
      }
    }
  },
  'fast-staging': {
    id: 'fast-staging',
    title: 'Hızlı Sanal Dizayn', // Removed (Gemini)
    description: 'Yapay zeka kullanarak boş mekanları hızla mobilyalı hale getirin.', // Updated description slightly
    longDescription: 'Yapay zeka gücünü kullanarak boş odalarınıza hızlı ve verimli bir şekilde mobilya ekleyin. Yüksek kaliteli sonuçlar için optimize edilmiştir.', // Updated description slightly
    icon: '⚡',
    deploymentId: 'gemini-image-generation', // Special ID to indicate Gemini usage
    mode: 'gemini-staging', // Custom mode for Gemini
    imageUrl: '/workflow-images/fast-staging.jpg', // Add a relevant image path
    credits: '8', // Set credit cost for Gemini generation
    active: true, // Mark as active
    version: 'V1 Gemini',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: false, // Needs prompt and image, maybe style later
    defaultStyle: 'contemporary', // Add a default style
    additionalInputs: { // Define inputs needed for Gemini staging
      room_type: {
        options: ["Living Room", "Bedroom", "Kitchen", "Bathroom", "Dining Room"],
        label: "Oda Tipi"
      },
      style: {
        options: ["scandinavian", "contemporary", "modern", "minimalist", "bohemian", "japandi", "parisian", "eclectic"], // Simplified styles for Gemini
        label: "Stil"
      }
      // Add other relevant inputs like color palette if needed later
    }
  },
  'furniture-removal': {
    id: 'furniture-removal',
    title: 'Mobilya Temizleme',
    description: 'Odalardan tüm mobilyaları ve eşyaları temizleyin, boş mekanlar oluşturun.',
    longDescription: 'Yapay zeka teknolojisi ile odalarınızdaki tüm mobilyaları, dekorasyonları ve kişisel eşyaları temizleyerek boş, temiz mekanlar oluşturun. Emlak fotoğrafçılığı ve iç mimari projeler için idealdir.',
    icon: '🧹',
    deploymentId: 'gemini-image-generation', // Use Gemini for furniture removal
    mode: 'furniture-removal', // Custom mode for furniture removal
    imageUrl: '/workflow-images/furniture-removal.jpg',
    credits: '5', // Lower cost than staging
    active: false,
    version: 'V1 Gemini',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: true, // Simple workflow, just needs an image
    additionalInputs: {
      room_type: {
        options: ["Living Room", "Bedroom", "Kitchen", "Bathroom", "Dining Room"],
        label: "Oda Tipi"
      },
      removal_intensity: {
        options: ["light", "medium", "complete"],
        label: "Temizleme Yoğunluğu"
      }
    }
  },
  'refurnish': {
    id: 'refurnish',
    title: 'İç Mekan Düzenleme',
    description: 'Mobilyalı odalarınızı yeniden hayal edin.',
    longDescription: 'Mobilyalı iç mekanlarınızı farklı stillerle yeniden tasarlamak için bir görsel yükleyin.',
    icon: '🏠',
    deploymentId: '595026ca-47d7-4d5e-8906-a88a3b93a2c4',
    mode: 'interior',
    imageUrl: '/workflow-images/sketch-to-furnish.jpg',
    credits: '10',
    active: false,
    version: 'V3',
    simpleInputs: false,
    additionalInputs: {
      room_type: {
        options: ["Living Room", "Bedroom", "Kitchen", "Bathroom", "Dining Room"],
        label: "Oda Tipi"
      }
    }
  },
  'staging': {
    id: 'staging',
    title: 'Sahne ve Stil Transferi',
    description: 'Refererans resimler ile boş iç mekanlarınızı yeniden tasarlayın ve mobilyalandırın',
    longDescription: 'Mevcut mekanınızın fotoğraflarını yükleyin ve AI destekli dizaynlara ve tasarımlara dönüştürün.',
    icon: '🛋️',
    deploymentId: '22f80a2e-1469-4601-b7a7-7bbd5b4df022',
    mode: 'interior',
    imageUrl: '/workflow-images/refurnishing.jpg',
    credits: '10',
    active: false,
    version: 'V1',
    requiresStyleImage: true,
    additionalInputs: {
      room_type: {
        options: ["Living Room", "Bedroom", "Kitchen", "Bathroom", "Dining Room"],
        label: "Oda Tipi"
      },
      style: {
        options: ["scandinavian", "contemporary", "modern", "minimalist", "bohemian", "japandi", "parisian", "eclectic"],
        label: "Stil"
      },
      color_theme: {
        options: ["original", "red", "blue", "green", "yellow", "brown", "white", "black", "grey", "purple", "pink", "orange"],
        label: "Renk Teması"
      }
    }
  },
  'inpaint': {
    id: 'inpaint',
    title: 'Seç ve Değiştir',
    description: 'İç mekanınızın yalnızca seçilen alanlarını dönüştürün',
    longDescription: 'İç mekanınızın belirli alanlarını seçerek yeniden tasarlamak ve geri kalanını korumak için maskeleme kullanın.',
    icon: '🎭',
    deploymentId: '716c3ff0-ada2-44c4-b4bd-7e576873ac1b',
    mode: 'interior',
    imageUrl: '/workflow-images/masking-transform.jpg',
    credits: '10',
    active: false,
    version: 'V1',
    requiresMasking: true,
    requiresStyleImage: false,
    requireMaskBeforeGenerate: true,
    defaultStyle: 'contemporary',
    additionalInputs: {
      room_type: {
        options: ["Living Room", "Bedroom", "Kitchen", "Bathroom"],
        label: "Oda Tipi"
      },
      style: {
        options: ["scandanavian", "contemporary", "modern", "countryside", "coastal", "wooden", "industrial", "italian", "traditional"],
        label: "Stil"
      },
      color_theme: {
        options: ["original", "red", "blue", "green", "yellow", "brown", "white", "black", "grey", "purple", "pink", "orange"],
        label: "Renk Teması"
      }
    }
  },
  'render-enhancer': {
    id: 'render-enhancer',
    title: 'Görsel İyileştirme',
    description: '3B görselleştirme çıktılarını iyileştirin',
    longDescription: 'Düşük kaliteli görselleri yapay zeka teknolojisi ile 8K çözünürlüğe kadar iyileştirin.',
    icon: '✨',
    deploymentId: 'f46b4d64-938b-407e-a28f-2f2f0e771501',
    mode: 'enhancement',
    imageUrl: '/workflow-images/render-enhancer.jpg',
    credits: '10',
    active: false,
    version: 'V2 burada!',
    simpleInputs: true
  },
  'ai-chat': {
    id: 'ai-chat',
    title: 'AI Asistanı',
    description: 'Mimari tasarım konusunda size özel AI asistanlarıı ile sohbet edin',
    longDescription: 'Mimari tasarım, iç mekan düzenleme ve dekorasyon konularında AI asistanı ile sohbet edin ve görsel oluşturun.',
    icon: '💬',
    deploymentId: 'aba5b280-9bf0-404a-9e7c-5907304428cd',
    mode: 'chat',
    imageUrl: '/workflow-images/ai-chat.jpg',
    credits: '5',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    path: '/chat'
  },
  'document-generator': {
    id: 'document-generator',
    title: 'Otomatik Blog Oluşturucu',
    description: 'Görsellerinizden ve açıklamalarınızdan profesyonel mimari bloglar ve yazı köşeleri oluşturun',
    longDescription: 'Görsellerinizi ve açıklamalarınızı kullanarak detaylı, bölümlere ayrılmış ve görsellerle zenginleştirilmiş profesyonel mimari belgeler oluşturun.',
    icon: '📄',
    deploymentId: 'document-generator',
    mode: 'document',
    imageUrl: '/workflow-images/document-generator.jpg',
    credits: '20',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: true,
    longDescription: 'Görsellerinizi ve açıklamalarınızı kullanarak detaylı, bölümlere ayrılmış ve görsellerle zenginleştirilmiş profesyonel mimari belgeler oluşturun.',
    icon: '📄',
    deploymentId: 'document-generator',
    mode: 'document',
    imageUrl: '/workflow-images/document-generator.jpg',
    credits: '20',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: true,
    path: '/document-generator',
  },
  'video-generator': {
    id: 'video-generator',
    title: 'İç Mekan Video Oluşturucu',
    description: 'İç mekan görsellerinizi kısa, dinamik kamera hareketli videolara dönüştürün',
    longDescription: 'Statik iç mekan görsellerinizi kısa, dinamik kamera hareketli videolara dönüştürün. Hızlı dönüşüm veya detaylı stüdyo modu ile çalışabilirsiniz.',
    icon: '🎬',
    deploymentId: 'be11c67b-2585-4f58-925f-2cb1aa48b84a',
    mode: 'video',
    imageUrl: '/workflow-images/video-generator.jpg',
    credits: '30',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: true,
    path: '/video-generator',
    additionalInputs: {
      camera_movement: {
        options: ["pan_left", "pan_right", "zoom_in", "zoom_out", "rotate", "dolly"],
        label: "Kamera Hareketi"
      },
      duration: {
        options: ["3", "4", "5", "6"],
        label: "Süre (saniye)"
      },
      quality: {
        options: ["draft", "standard", "high"],
        label: "Kalite"
        // Removed duplicate label line
      }
    }
  },
  'image-editor': {
    id: 'image-editor',
    title: 'Görsel Düzenleyici',
    description: 'Görsellerinizi düzenleyin, iyileştirin ve yapay zeka ile dönüştürün.',
    longDescription: 'Mimari tasarım, iç mekan düzenleme ve dekorasyon konularında AI asistanı ile sohbet edin ve görsel oluşturun.',
    icon: '💬',
    deploymentId: 'aba5b280-9bf0-404a-9e7c-5907304428cd',
    mode: 'chat',
    imageUrl: '/workflow-images/ai-chat.jpg',
    credits: '5',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    longDescription: 'Görsellerinizi kırpın, ayarlayın, not ekleyin ve yapay zeka destekli araçlarla dönüştürün. Sihirli silgi, sanal dizayn, yeniden dekore etme ve daha fazlası.',
    icon: '🖌️',
    deploymentId: 'image-editor',
    mode: 'editor',
    imageUrl: '/workflow-images/image-editor.jpg',
    credits: '0',
    active: false,
    version: 'V1',
    requiresStyleImage: false,
    requireMaskBeforeGenerate: false,
    simpleInputs: true,
    path: '/gallery'
  }
};

// Export the workflows array in the desired order
export const canvasWorkflows = workflowOrder.map(id => workflowsById[id]).filter(Boolean);
// Removed all duplicated code blocks from here onwards
